import { ON_SALE_EVENTS_TABLE_COLUMNS_CONFIG } from 'src/navigations/Routes/OnSaleDiscovery/OnSaleDiscoveryView.constants';
import { OnSaleEventTableColumnId } from 'src/navigations/Routes/OnSaleDiscovery/OnSaleDiscoveryView.types';
import { MarketplacePaymentsTableColumnId } from 'src/utils/columns/marketplacePayments/marketplacePaymentsColumnsUtils.types';
import {
  PAYMENTS_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES,
  PAYMENTS_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG,
} from 'src/utils/columns/payments/paymentsColumnUtils.constants';
import { CustomMarketplacePaymentsColumn } from 'src/utils/columns/payments/paymentsCustomColumnUtils.types';
import {
  PURCHASES_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES,
  PURCHASES_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG,
} from 'src/utils/columns/purchases/purchasesColumnUtils.constants';
import { PurchasesTableColumnId } from 'src/utils/columns/purchases/purchasesColumnUtils.types';
import { getPersonalizationFlagsFromFormula as getPersonalizationFlagsFromFormulaPurchases } from 'src/utils/columns/purchases/purchasesCustomColumnUtils';
import { CustomPurchasesColumn } from 'src/utils/columns/purchases/purchasesCustomColumnUtils.types';
import { ReportTag, Tag, TagsValueType } from 'src/WebApiController';

import { FLIGHTS_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES } from '../../tables/SponsoredListings/CampaignFlightsTable/FlightsTableColumnConfig';
import { CAMPAIGNS_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES } from '../../tables/SponsoredListings/CampaignsTableV2/CampaignsTableV2ColumnConfig';
import { SectionType } from '../types/sectionType';
import { AdCampaignsListingsColumn } from './adCampaigns/adCampaignsCustomColumnUtils.types';
import { AdGroupsListingsColumn } from './adGroups/adGroupsCustomColumnUtils.types';
import { PERSONALIZATION_DEFAULTS } from './columnUtils.types';
import {
  EVENTS_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES,
  ON_SALE_EVENTS_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES,
} from './events/eventsColumnUtils.constants';
import { EventsTableColumnId } from './events/eventsColumnUtils.types';
import { getPersonalizationFlagsFromFormula as getPersonalizationFlagsFromFormulaEvents } from './events/eventsCustomColumnUtils';
import { EVENTS_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG } from './events/eventsCustomColumnUtils.constants';
import {
  CustomEventsColumn,
  CustomOnSaleEventsColumn,
} from './events/eventsCustomColumnUtils.types';
import {
  LISTING_REPORT_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES,
  LISTING_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES,
  LISTING_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG,
} from './inventory/inventoryColumnUtils.constants';
import {
  ListingReportTableColumnId,
  ListingTableColumnId,
  ListingTableFlattenedColumnId,
} from './inventory/inventoryColumnUtils.types';
import { getPersonalizationFlagsFromFormula as getPersonalizationFlagsFromFormulaListings } from './inventory/inventoryCustomColumnUtils';
import { CustomListingColumn } from './inventory/inventoryCustomColumnUtils.types';
import { getPersonalizationFlagsFromFormula as getPersonalizationFlagsFromFormulaListingsReport } from './inventory/inventoryReportCustomColumnUtils';
import { SALE_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES } from './sales/salesColumnUtils.constants';
import {
  RecentSalesTableColumnId,
  SalesReportTableColumnId,
  SalesTableColumnId,
  SalesTableFlattenedColumnId,
} from './sales/salesColumnUtils.types';
import {
  getPersonalizationFlagsFromFormula as getPersonalizationFlagsFromFormulaSales,
  SALE_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG,
} from './sales/salesCustomColumnUtils';
import { CustomSalesColumn } from './sales/salesCustomColumnUtils.types';
import { SALE_REPORT_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES } from './sales/salesReportColumnUtils.constants';

export const getColumnPersonalization = ({
  id,
  sectionType,
  matchingCustomColumn,
  matchingTag,
}: {
  id: string;
  sectionType: SectionType;
  matchingCustomColumn?:
    | CustomListingColumn
    | CustomSalesColumn
    | CustomEventsColumn
    | CustomPurchasesColumn
    | AdCampaignsListingsColumn
    | AdGroupsListingsColumn
    | CustomMarketplacePaymentsColumn
    | CustomOnSaleEventsColumn;
  matchingTag?: Tag | ReportTag;
}) => {
  const personalizationDefaults = { ...PERSONALIZATION_DEFAULTS };

  if (matchingTag) {
    personalizationDefaults.isNumeric =
      matchingTag.valueType === TagsValueType.Int ||
      matchingTag.valueType === TagsValueType.Decimal;
    personalizationDefaults.isInteger =
      matchingTag.valueType === TagsValueType.Int;

    return { ...personalizationDefaults };
  } else {
    const {
      customColumnPersonalizationConfig,
      personalizationOverride,
      getPersonalizationFlagsFromFormula,
    } =
      sectionType === SectionType.Listings ||
      sectionType === SectionType.ListingsFlattened
        ? {
            customColumnPersonalizationConfig:
              LISTING_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG,
            personalizationOverride:
              LISTING_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES[
                id as ListingTableColumnId | ListingTableFlattenedColumnId
              ],
            getPersonalizationFlagsFromFormula:
              getPersonalizationFlagsFromFormulaListings,
          }
        : sectionType === SectionType.InventorySideTable
          ? {
              customColumnPersonalizationConfig:
                LISTING_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG,
              personalizationOverride:
                LISTING_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES[
                  id as ListingTableColumnId | ListingTableFlattenedColumnId
                ],
              getPersonalizationFlagsFromFormula:
                getPersonalizationFlagsFromFormulaListingsReport,
            }
          : sectionType === SectionType.ListingsReport
            ? {
                customColumnPersonalizationConfig:
                  LISTING_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG,
                personalizationOverride:
                  LISTING_REPORT_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES[
                    id as ListingReportTableColumnId
                  ],
                getPersonalizationFlagsFromFormula:
                  getPersonalizationFlagsFromFormulaListingsReport,
              }
            : sectionType === SectionType.Sales ||
                sectionType === SectionType.SalesFlattened ||
                sectionType === SectionType.SalesSideTable ||
                sectionType === SectionType.RecentSalesTable
              ? {
                  customColumnPersonalizationConfig:
                    SALE_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG,
                  personalizationOverride:
                    SALE_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES[
                      id as
                        | SalesTableColumnId
                        | SalesTableFlattenedColumnId
                        | RecentSalesTableColumnId
                    ],
                  getPersonalizationFlagsFromFormula:
                    getPersonalizationFlagsFromFormulaSales,
                }
              : sectionType === SectionType.SalesReport
                ? {
                    customColumnPersonalizationConfig:
                      SALE_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG,
                    personalizationOverride:
                      SALE_REPORT_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES[
                        id as SalesReportTableColumnId
                      ],
                    getPersonalizationFlagsFromFormula:
                      getPersonalizationFlagsFromFormulaSales,
                  }
                : sectionType === SectionType.Purchases ||
                    sectionType === SectionType.PurchaseEvent ||
                    sectionType === SectionType.PurchaseSideTable
                  ? {
                      customColumnPersonalizationConfig:
                        PURCHASES_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG,
                      personalizationOverride:
                        PURCHASES_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES[
                          id as PurchasesTableColumnId
                        ],
                      getPersonalizationFlagsFromFormula:
                        getPersonalizationFlagsFromFormulaPurchases,
                    }
                  : sectionType === SectionType.MarketplacePaymentsTable
                    ? {
                        customColumnPersonalizationConfig:
                          PAYMENTS_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG,
                        personalizationOverride:
                          PAYMENTS_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES[
                            id as MarketplacePaymentsTableColumnId
                          ],
                        getPersonalizationFlagsFromFormula: () => ({
                          isCurrency: false,
                          isPercent: false,
                        }),
                      }
                    : sectionType === SectionType.OnSaleEvents
                      ? {
                          customColumnPersonalizationConfig:
                            ON_SALE_EVENTS_TABLE_COLUMNS_CONFIG,
                          personalizationOverride:
                            ON_SALE_EVENTS_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES[
                              id as OnSaleEventTableColumnId
                            ],
                          getPersonalizationFlagsFromFormula:
                            getPersonalizationFlagsFromFormulaEvents,
                        }
                      : sectionType === SectionType.Retail
                        ? {
                            customColumnPersonalizationConfig: undefined,
                            personalizationOverride: undefined,
                            getPersonalizationFlagsFromFormula: () => ({
                              isCurrency: false,
                              isPercent: false,
                            }),
                          }
                        : sectionType === SectionType.CampaignsTable
                          ? {
                              customColumnPersonalizationConfig: undefined,
                              personalizationOverride:
                                CAMPAIGNS_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES[
                                  id as never
                                ],
                              getPersonalizationFlagsFromFormula: () => ({
                                isCurrency: false,
                                isPercent: false,
                              }),
                            }
                          : sectionType === SectionType.FlightsTable
                            ? {
                                customColumnPersonalizationConfig: undefined,
                                personalizationOverride:
                                  FLIGHTS_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES[
                                    id as never
                                  ],
                                getPersonalizationFlagsFromFormula: () => ({
                                  isCurrency: false,
                                  isPercent: false,
                                }),
                              }
                            : // SectionType.Event
                              {
                                customColumnPersonalizationConfig:
                                  EVENTS_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG,
                                personalizationOverride:
                                  EVENTS_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES[
                                    id as EventsTableColumnId
                                  ],
                                getPersonalizationFlagsFromFormula:
                                  getPersonalizationFlagsFromFormulaEvents,
                              };

    const personalization = matchingCustomColumn
      ? customColumnPersonalizationConfig
      : personalizationOverride;

    if (matchingCustomColumn?.formula) {
      const personalizationFromMathToken = getPersonalizationFlagsFromFormula(
        matchingCustomColumn.formula
      );
      personalizationDefaults.isCurrency =
        personalizationFromMathToken.isCurrency ??
        personalizationDefaults.isCurrency;
      personalizationDefaults.isPercent =
        personalizationFromMathToken.isPercent ??
        personalizationDefaults.isPercent;
    }

    return { ...personalizationDefaults, ...personalization };
  }
};
